export default __webpack_public_path__ + "static/media/ADEN-Acrópolis-QR-GooglePlay.ddde3730.png";